import { createSlice } from '@reduxjs/toolkit';
import { handleGetMasterData } from './masterThunk';
import { IMasterData } from '~/utils/interface/master';
import { cast } from '~/utils/helper';

export interface MasterState extends IMasterData {}

const initialState: MasterState = {
  jobTypes: [],
  jobCostTypes: [],
  jobCategories: [],
  jobCostSubTypes: [],
  addtionalContactAdjusters: [],
  addtionalContactTypes: [],
  eventColors: [],
};

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(handleGetMasterData.fulfilled, (state, action) => {
      if (action.payload.jobTypes) state.jobTypes = action.payload.jobTypes;
      if (action.payload.jobCostTypes) state.jobCostTypes = action.payload.jobCostTypes;
      if (action.payload.jobCategories) state.jobCategories = action.payload.jobCategories;
      if (action.payload.jobCostSubTypes) state.jobCostSubTypes = action.payload.jobCostSubTypes;
      if (action.payload.addtionalContactAdjusters) {
        state.addtionalContactAdjusters = action.payload.addtionalContactAdjusters.map((item) => ({
          id: cast(item),
          name: cast(item),
        }));
      }
      if (action.payload.addtionalContactTypes) {
        state.addtionalContactTypes = action.payload.addtionalContactTypes.map((item) => ({
          id: cast(item),
          name: cast(item),
        }));
      }
      if (action.payload.customers) state.customers = action.payload.customers;
      if (action.payload.eventColors) state.eventColors = action.payload.eventColors;
    });
  },
});

export const masterActions = masterSlice.actions;

const masterReducer = masterSlice.reducer;
export default masterReducer;
